<template>
    <div>
        <file-upload name="resume" class="mr-1" @loaded="setAttachments"></file-upload>
        <!-- <button type="button" class="btn btn-blue text-xs" @click="addAttachment(i)" v-if="fileReady">Attach</button> -->
    </div>
</template>

<script>
    import FileUpload from './FileUpload.vue';
    export default {
        components: {FileUpload},
        // props: ['assignment', 'upload', 'readOnly'],
        data() {
            return {
                // attachments: this.assignment.attachments,
                newAttachment: '',
                // uploading: this.upload || false,
                // editable: ! this.readOnly || false,
                // fileReady: false
            }
        },
        methods: {
            setAttachments(doc){
                console.log(doc);
                this.newAttachment = doc.file;
                this.addAttachment();
            },
            addAttachment() {
                let data = new FormData();
                data.append('attachment', this.newAttachment);
                // axios.post(`/assignments/${this.assignment.id}/attachments`, data)
                //     .then(({data}) => {
                //         this.newAttachment = '';
                //         // this.fileReady = false;
                //         this.attachments.push(data);
                //     });
                axios.post('/coders/upload_resume', data).then(({data}) => {
                    location.reload();
                })
            },
            // removeAttachment(id, docI) {
            //     axios.delete(`/attachments/${id}`)
            //         .then(({data}) => {
            //             this.attachments.splice(docI, 1);
            //         })
            // },
            // visited(id) {
            //     let current_url = window.location.href;
            //     history.replaceState({}, "", `/assignments/${this.assignment.id}/download/${id}`);
            //     history.replaceState({}, "", current_url); // will autodownload last file on page reload if this isn't here
            // }
            // download(id) {
            //     axios.get(`/assignments/${this.assignment.id}/download/${this.document.id}`);
            //         // .then(({data}) => {

            //         // })
            // }
        }
    }
</script>